// import React from "react";
// import CreateMeetingForm from "./CreateMeetingForm";

// const CreateMeetingDashboard = () => {
//   return (
//     <div className="admin-container">
//       <div className="max-w-xl w-full shadow-lg rounded-lg p-6 space-y-6">
//         <h2 className="text-3xl font-semibold text-gray-800 text-center">Create Session</h2>
//         <CreateMeetingForm />
//       </div>
//     </div>
//   );
// };

// export default CreateMeetingDashboard;

import React, { useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import Navbar from "../../components/Navbar";
import CreateMeetingForm from "./CreateMeetingForm";
import { useNavigate } from "react-router-dom";

const CreateMeetingDashboard = () => {
  const navigate = useNavigate();
  const {
      isAdmin,
    } = useContext(AuthContext);
  useEffect(() => {
    if (!isAdmin) {
      navigate("/", { replace: true });
    }
  }, [isAdmin, navigate]);
  
  
  return (
    <div>
      <Navbar
      />
      <div className="mt-20 admin-container">
        <div className="max-w-xl w-full shadow-lg rounded-lg p-6 space-y-6">
          <h2 className="text-3xl font-semibold text-gray-800 text-center">Create Meeting</h2>
          <CreateMeetingForm />
        </div>
      </div>
    </div>
  );
};

export default CreateMeetingDashboard;
